"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementBoundingBox = getElementBoundingBox;

var _svgPathBoundingBox = _interopRequireDefault(require("svg-path-bounding-box"));

var _svg = require("./svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getElementBoundingBox(element) {
  if (element.className === 'Path') {
    var path = (0, _svg.elementToSVGPath)(element);

    var _getPathBoundingBox = (0, _svgPathBoundingBox.default)(path),
        x1 = _getPathBoundingBox.x1,
        y1 = _getPathBoundingBox.y1,
        x2 = _getPathBoundingBox.x2,
        y2 = _getPathBoundingBox.y2;

    return [[x1, y1], [x2, y1], [x1, y2], [x2, y2]];
  }

  if (element.size) {
    return [[0, 0], [element.size[0], 0], [0, element.size[1]], [element.size[0], element.size[1]]];
  }

  throw new Error("Unsupported element: ".concat(element.className));
}